export default {
  Title: 'ใบแจ้งหนี้',
  buttonNewInvoice: 'สร้างใบแจ้งหนี้',
  buttonNewInvoiceAndReceipt: 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
  Customer: 'ลูกค้า',
  buttonPrintInvoice: 'พิมพ์ใบแจ้งหนี้',
  buttonPrintInvoiceTemporary: 'พิมพ์ใบแจ้งหนี้ชั่วคราว',
  buttonPrintReceipt: 'พิมพ์ใบเสร็จรับเงิน',
  buttonPrintReceiptInvoice: 'พิมพ์ใบเสร็จรับเงิน และใบกำกับภาษี',
  buttonnewCustomerDepartment: 'New Customer Department',
  buttonDeleteCustomer: 'Delete Customer',
  buttonDeleteCustomerDepartment: 'Delete Customer Department',
  newCustomer: 'New Customer',
  editCustomer: 'Edit Customer',
  newCustomerDepartment: 'New Customer Department',
  editCustomerDepartment: 'Edit Customer Department',
  CustomerName: 'หน่วยงาน',
  CustomerAddress: 'ที่อยู่',
  confirmDelete: 'Are you sure you want to delete Customer {}?',
  confirmCustomerDepartmentDelete: 'Are you sure you want to delete Customer Department {}?',
  confirmDeleteSelected: 'Are you sure you want to delete selected Customer?',
  confirmCustomerDepartmentDeleteSelected: 'Are you sure you want to delete selected Customer Department?',
  progressMessageDelete: 'Deleting Customer {}',
  progressMessageCustomerDepartmentDelete: 'Deleting Customer Department {}',
  messageDeleteNotSelected: 'Please select Customer to delete',
  messageDeleteDepartmentNotSelected: 'Please select Customer Department to delete',
  tabWindow: 'Window',
  tabDepartment: 'Department',
  AddPicture: 'Add Picture',
  CustomerDetail: 'Customer Detail',
  criteria: 'เงื่อนไขการค้นหา',
  Status: 'สถานะ',
  ReceivedDate: 'Received Date',
  ApproveDate: 'Approved Date',
  OrderId: 'Package No.',
  LabNo: 'เลขที่สั่งตรวจ',
  patientName: 'ชื่อ-นามสกุล',
  gender: 'เพศ',
  age: 'อายุ',
  hn: 'HN',
  labStatus: 'สถานะการสั่งตรวจ',
  totalAmt: 'จำนวนเงิน',
  InvoiceNo: 'เลขที่ใบแจ้งหนี้',
  ReceiptNo: 'Receipt No',
  messageCreateInvoice: 'คุณต้องการสร้างใบแจ้งหนี้ใช่หรือไม่',
  messageNoSelection: 'กรุณาเลือกรายงานแล็บ',
  messageNotHaveAmt: 'Package No. {} not have amount.',
  messageDifferentCustomer: 'ไม่สามารถเลือกแล็บที่มีลูกค้าต่างกันได้ กรุณาเลือกแล็บของลูกค้า {}',
  messageCreateInvoiceSuccess: 'Invoice has been successfully created. Invoice number: {}',
  OrderItem: 'รายการสั่งตรวจ',
  OrderItemNo: 'รหัสรายการสั่งตรวจ',
  price: 'ราคา',
  qty: 'จำนวน',
  discAmount: 'ส่วนลด',
  InvoiceAmount: 'ราคารวม',
  InvoiceDate: 'Invoice Date',
  ReceiptDate: 'Receipt Date',
  CreatedDate: 'วันที่',
  CreatedUser: 'Created User',
  messageCreateReceipt: 'คุณต้องการสร้างใบแจ้งหนี้ และรับชำระเงินใช่หรือไม่',
  messagePaymentMethod: 'กรุณาเลือกวิธีการชำระเงิน',
  PaymentMethod: 'วิธีการชำระเงิน',
  messageCreateInvoiceReceiptSuccess: 'Invoice and Receipt has been successfully created. Invoice number: {}, Receipt number: {}',
  messageAmountZero: 'กรุณาใส่จำนวนเงิน',
  messageCreateReceiptAmtExceedInvAmt: 'Do you want to accept payments that exceed the invoiced amount?',
  messageCreateReceiptAmtlessInvAmt: 'Do you want to accept payments that are less than the invoiced amount?',
  ref1: 'เลขที่อ้างอิง',
  ref2: 'Ref.2',
  ref3: 'Ref.3',
  ReceiptAmt: 'Receipt Amt.',
  messageInvoiceNotFound: 'Invoice No. Not Found.',
  dateSend: 'วันที่ส่งตรวจ',
  TransferSlipDate: 'วันที่โอนตามสลิป',
  TransferSlipTime: 'เวลาโอนตามสลิป',
  remark: 'หมายเหตุ',
  buttonExportInvoice: 'Export',
  buttonGenerateDeferredRevenue: 'Generate Deferred Revenue',
  messageAlertNoInvoice: 'Package No. {} ยังไม่ได้ออกใบแจ้งหนี้',
  messageGenerateDeferredRevenusSuccessfully: 'Generate deferred revenus successfully',
  DeferredRevenue: 'รายได้รับล่วงหน้า',
  DeferredRevenueHas: 'มีรายการที่เป็นรายได้รับล่วงหน้า',
  AttachAmountPaid: 'จำนวนเงินที่ชำระ',
  withHoldingTax: 'ภาษีหัก ณ ที่จ่าย',
  withHoldingTaxAmt: 'จำนวนเงิน (หลังหัก WHT)',
  InvoiceTemporary: 'ใบแจ้งหนี้ชั่วคราว',
  buttonAutoSelect: 'Auto Select',
  messagePleaseSelectCustomer: 'กรุณาเลือกหน่วยงาน',
  AttachAmountPaidInvScreen: 'จำนวนเงินที่รับโอน',
  BankTransfer: 'ธนาคารที่โอน',
  messageSelectInvoiceBeforePrint: 'กรุณาเลือก Order Item',
  messageReceiptNotFound: 'Receipt No. Not Found.',
  AttachAmountPaidTransfer: 'จำนวนเงินที่รับโอน',
  searchData: 'ค้นหา',
}
